import React, { useState, useEffect } from "react";
import { Button, FormControl, InputLabel, MenuItem, TableRow, Table, TableHead, TableBody, TableCell,
    TableContainer,
              Paper
 } from "@material-ui/core";
import ActivityService from "./Locality/Service/activityService";
import { Grid, Card, Box, Select } from "@material-ui/core";
import StudentService from "./Locality/Service/studentService";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
}));

export default function ReportOfActivities() {
    const tableHeaders = ['Class', 'Section', 'Student Name', 'Area of Work', 'List of Activities', 'Exercise', 'Remarks', 'Date', 'Key'];
    const classes = useStyles();
    const [activityList, setActivityList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [classId, setClassId] = useState("");
    const [sectionId, setSectionId] = useState("");
    const [sectionList, setSectionList] = useState([]);
    const [studentId, setStudentId] = useState("");
    const [keyValue, setKeyValue] = useState("");
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const [pg, setPg] = useState(0);
    const [rpg, setRpg] = useState(100);

    useEffect(() => {
        getAddClassList();
        return () => {
            setActivityList([]);
            setAddClassList([]);
            setStudentList([]);
        };
    }, []);

    const getSectionListByClass = (selectedClassId) => {
        if (!selectedClassId) {
            setSectionList([]);
            setSectionId("");
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === "TEACHER" && userDetails.sectionId) {
                //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
                // }
                setSectionList(list);
                // if (userDetails.role === "TEACHER" && userDetails.sectionId && list.length > 0) {
                //     setSectionId(userDetails.sectionId);
                // }
            })
            .catch(() => setSectionList([]));
    };

    const getAddClassList = () => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            let list = res;
            // if (userDetails.role === "TEACHER" && userDetails.classId) {
            //     list = res.filter((item) => item._id === userDetails.classId);
            // }
            setAddClassList(list);
            if (userDetails.role === "TEACHER" && userDetails.classId) {
                setClassId(userDetails.classId);
                setSectionId(userDetails.sectionId || "");
                getSectionListByClass(userDetails.classId);
                getStudentList(userDetails.classId, userDetails.sectionId || undefined);
            } else if (list.length > 0) {
                const firstClassId = list[0]._id;
                setClassId(firstClassId);
                setSectionId("");
                getSectionListByClass(firstClassId);
                getStudentList(firstClassId);
            } else {
                setClassId("");
            }
        }).catch((err) => {});
    };

    const findActivityList = () => {
        let mappedKey = keyValue;
        if (keyValue === "A") mappedKey = "Works with Assistance";
        if (keyValue === "I") mappedKey = "Works Independently";
        if (keyValue === "N") mappedKey = "Presented(1)";

        const keys = {
            classId: classId,
            schooleId: userDetails.schooleId,
            studentId: studentId,
            ...(sectionId && { sectionId }),
            ...(mappedKey && { key: mappedKey })
        };

        console.log("Filter keys:", keys);

        ActivityService.findActivityList(keys).then((res) => {
            console.log("API Response:", res);
            setActivityList(res);
        }).catch((err) => {
            console.error("API Error:", err);
        });
    };

    const getStudentList = (selectedClassId, overrideSectionId) => {
        if (!selectedClassId) return;
        const body = { classId: selectedClassId };
        const effectiveSectionId = overrideSectionId !== undefined ? overrideSectionId : (sectionId || userDetails.sectionId);
        if (effectiveSectionId) body.sectionId = effectiveSectionId;
        StudentService.getAllStudentById(userDetails.schooleId, body).then((res) => {
            const studentDetails = res.map(res => ({
                _id: res._id,
                studentName: `${res.firstName} ${res.lastName}`,
                status: true
            }));
            setStudentList(studentDetails);
        }).catch((err) => {});
    };

    // Filter activityList to only include entries with records
    const filteredActivityList = activityList.filter(activitydetails => 
        activitydetails.activityRecordsId && activitydetails.activityRecordsId.length > 0
    );

    return (
        <>
            <PageTitle title="Activity Reports" />
            <Card sx={{ maxWidth: 345 }}>
                <Box>
                    <Grid container spacing={2} columns={12} style={{ margin: 10 }}>
                        <Grid item xs={12} sm={6} md={2}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="className"
                                    name="classId"
                                    label="className"
                                    value={classId}
                                    onChange={e => {
                                        const selected = e.target.value;
                                        setClassId(selected);
                                        setSectionId("");
                                        getSectionListByClass(selected);
                                        getStudentList(selected, undefined);
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="section-select-label">Section (Optional)</InputLabel>
                                <Select
                                    labelId="section-select-label"
                                    id="section-select"
                                    value={sectionId}
                                    onChange={e => {
                                        const newSectionId = e.target.value;
                                        setSectionId(newSectionId);
                                        if (classId) getStudentList(classId, newSectionId || undefined);
                                    }}
                                    disabled={!classId || sectionList.length === 0}
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {sectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="studentName">Student Name</InputLabel>
                                <Select
                                    labelId="studentName"
                                    id="studentName"
                                    label="Student Name"
                                    name="studentId"
                                    value={studentId}
                                    onChange={e => setStudentId(e.target.value)}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {studentList.map(({ _id, studentName }, index) => (
                                        <MenuItem key={index} value={_id}>{studentName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Select Key</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    label="Key"
                                    name="key"
                                    value={keyValue}
                                    onChange={e => setKeyValue(e.target.value)}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="A">Works with Assistance</MenuItem>
                                    <MenuItem value="I">Works Independently</MenuItem>
                                    <MenuItem value="N">Presented</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Button
                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                type="button"
                                onClick={findActivityList}
                                variant="contained"
                            >
                                Search
                            </Button>
                        </Grid>
                        </Grid>
                        </Box>
                        </Card>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                                                            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                                    
                                    <Table stickyHeader className="mb-0">
                                        <TableHead>
                                            <TableRow>
                                                {tableHeaders.map(key => (
                                                    <StyledTableCell key={key}>{key}</StyledTableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredActivityList.length > 0 ? (
                                                filteredActivityList.slice(pg * rpg, pg * rpg + rpg).map((activitydetails) =>
                                                    activitydetails.activityRecordsId.map((record) => (
                                                        <TableRow key={record._id}>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {activitydetails.classId ? activitydetails.classId.className : ''}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {activitydetails.sectionId ? activitydetails.sectionId.sectionName : '-'}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {activitydetails.studentId ? `${activitydetails.studentId.firstName} ${activitydetails.studentId.lastName}` : ""}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.superActivityId ? record.superActivityId.superActivityName : "N/A"}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.activityId ? record.activityId.activityName : "N/A"}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.subActivityId ? record.subActivityId.subActivityName : "N/A"}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.remarks}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.date}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.key}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={9}>No Records</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                    </TableContainer >
                                </Widget>
                            </Grid>
                        </Grid>
                    
               
        </>
    );
}